import { useQuery } from '@tanstack/react-query';

type GeoLocationData = {
  ip?: string;
  IPv4?: string;
  city?: string;
  region_code?: string;
  region?: string;
  state?: string;
  country?: string;
  country_code?: string;
  country_name?: string;
};

export const useGetGeoLocation = () =>
  useQuery<GeoLocationData>({
    queryKey: ['customer', 'geoLocation'],
    queryFn: getGeoLocation,
  });

const getGeoLocation = async () => {
  return await getGeoLocationData();
};

const getGeoLocationData = async () => {
  try {
    const response1 = await fetch('https://ipapi.co/json/');

    if (!response1.ok) throw new Error('First endpoint failed');

    return await response1.json();
  } catch {
    const response2 = await fetch('https://geolocation-db.com/json/');

    if (!response2.ok) throw new Error('Second endpoint failed');

    return await response2.json();
  }
};
